"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var optimzely_types_exports = {};
__export(optimzely_types_exports, {
  EventName: () => EventName,
  Experiment: () => Experiment,
  OptimizelyActionType: () => OptimizelyActionType
});
module.exports = __toCommonJS(optimzely_types_exports);
var EventName = /* @__PURE__ */ ((EventName2) => {
  EventName2["CLICK_CATEGORY_SEARCH"] = "click-category-search";
  EventName2["CONTACT_CONVERSION"] = "contact_conversion";
  EventName2["EXAMPLE_A_A_OPTI_ONLY"] = "example_a_a_opti_only";
  EventName2["JOB_DESCRIPTION_LENGTH"] = "job_description_length";
  return EventName2;
})(EventName || {});
var Experiment = /* @__PURE__ */ ((Experiment2) => {
  Experiment2["APP_PROMOTION_POPUP"] = "global-app-promotion-popup";
  Experiment2["TEST"] = "experiment-flag";
  Experiment2["CA1507"] = "ca-1507_reviews";
  Experiment2["PERSISTENT_A_A"] = "persistent_a_a";
  Experiment2["JOB_DESCRIPTION_GUIDANCE"] = "job-description-guidance";
  Experiment2["HOMEPAGE_HERO_TEXT_CMA"] = "homepage-hero-text-cma";
  Experiment2["TRADE_CONTACT_CTA"] = "trade-contact-cta";
  Experiment2["RAQ_ENTRY_POINT"] = "raq_entry_point";
  Experiment2["LEAD_ENRICHMENT_FORM"] = "lead_enrichment_form";
  Experiment2["SEMANTIC_SEARCH_VARIANTS"] = "md-780-semantic-search-variants";
  Experiment2["BOOKABLE_SERVICES_FLOW_FLAG"] = "bookable-services-flow-flag";
  Experiment2["SHOW_ALTERNATIVE_TRADES"] = "tp-184-show-alternative-trades-carousel";
  Experiment2["SHOW_SAVE_ICON"] = "sut-394_login_save_trades";
  Experiment2["NEW_SEARCH_BAR_MODAL"] = "new_search_bar_modal";
  Experiment2["SOCIAL_PROOFING_BADGE"] = "social-proofing-badge";
  Experiment2["ZERO_AUTH_PAYMENTS_FLAG"] = "zero-auth-payments-flow-flag";
  return Experiment2;
})(Experiment || {});
var OptimizelyActionType = /* @__PURE__ */ ((OptimizelyActionType2) => {
  OptimizelyActionType2["SET_CLIENT"] = "SET_CLIENT";
  OptimizelyActionType2["SET_USER"] = "SET_USER";
  return OptimizelyActionType2;
})(OptimizelyActionType || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EventName,
  Experiment,
  OptimizelyActionType
});
